export default __webpack_public_path__ + "static/media/dynaslope_seal.4d5646bb.png";